/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetBracketsMatchesMatchidTeamStatsQueryResponse,
  GetBracketsMatchesMatchidTeamStatsPathParams,
} from "../types/GetBracketsMatchesMatchidTeamStats.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getBracketsMatchesMatchidTeamStatsQueryKey = (
  matchId: GetBracketsMatchesMatchidTeamStatsPathParams["matchId"] | undefined,
) =>
  [
    {
      url: "/brackets/matches/:matchId/team-stats",
      params: { matchId: matchId },
    },
  ] as const;

export type GetBracketsMatchesMatchidTeamStatsQueryKey = ReturnType<
  typeof getBracketsMatchesMatchidTeamStatsQueryKey
>;

/**
 * @summary KAN-790: командная статистика по каждой игре матча — обе стороны.
 * Отвечает на вопрос «как сыграли команды», которого не закрывал ни один прежний
 * срез: метрики игрока показывали пятерых по отдельности, а разбор матча —
 * только лидеров направлений.
 * {@link /brackets/matches/:matchId/team-stats}
 */
export async function getBracketsMatchesMatchidTeamStats(
  matchId: GetBracketsMatchesMatchidTeamStatsPathParams["matchId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetBracketsMatchesMatchidTeamStatsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/brackets/matches/${matchId}/team-stats`,
    ...requestConfig,
  });
  return res;
}

export function getBracketsMatchesMatchidTeamStatsQueryOptions(
  matchId: GetBracketsMatchesMatchidTeamStatsPathParams["matchId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getBracketsMatchesMatchidTeamStatsQueryKey(matchId);
  return queryOptions<
    ResponseConfig<GetBracketsMatchesMatchidTeamStatsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetBracketsMatchesMatchidTeamStatsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!matchId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getBracketsMatchesMatchidTeamStats(matchId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary KAN-790: командная статистика по каждой игре матча — обе стороны.
 * Отвечает на вопрос «как сыграли команды», которого не закрывал ни один прежний
 * срез: метрики игрока показывали пятерых по отдельности, а разбор матча —
 * только лидеров направлений.
 * {@link /brackets/matches/:matchId/team-stats}
 */
export function useGetBracketsMatchesMatchidTeamStats<
  TData = ResponseConfig<GetBracketsMatchesMatchidTeamStatsQueryResponse>,
  TQueryData = ResponseConfig<GetBracketsMatchesMatchidTeamStatsQueryResponse>,
  TQueryKey extends QueryKey = GetBracketsMatchesMatchidTeamStatsQueryKey,
>(
  matchId: GetBracketsMatchesMatchidTeamStatsPathParams["matchId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetBracketsMatchesMatchidTeamStatsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getBracketsMatchesMatchidTeamStatsQueryKey(matchId);

  const query = useQuery(
    {
      ...getBracketsMatchesMatchidTeamStatsQueryOptions(matchId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
